import React, { useState, useEffect } from 'react'

import CameraOCR from '../camera/tesseract'
import { Button, Input, Modal, message, Tabs, Steps, Space, Select, Spin, Alert } from 'antd'

const { TextArea } = Input
import Icon from 'src/@core/components/icon'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

import { androidWaKey } from '/src/@api/dashboard'

import { gcloudDownload } from 'src/@api/login'

const { TabPane } = Tabs

import { useTranslation } from 'src/utils/i18n'
import { messageInfo } from 'src/components/Message'
import { MoreOutlined } from '@ant-design/icons'

const EncryptionKey = ({ }) => {
  const { t } = useTranslation('androidLogin')

  const [messageApi, contextHolder] = message.useMessage()

  //识别出来的文字
  // const [recognizedText, setRecognizedText] = useState('')

  // 回调函数，用于接收子组件传来的 text
  const handleTextChange = text => {
    setDigitKey(text)
  }

  // useEffect(() => {
  //   setDigitKey(recognizedText)
  // }, [recognizedText])

  let encryptionStatus = localStorage.getItem('encryption-key') === null ? true : false

  try {
    if (!encryptionStatus) {
      encryptionStatus = JSON.parse(localStorage.getItem('userSummary'))[1].num === 0 ? true : false
    }
  } catch (error) { }

  const [isModalOpen, setIsModalOpen] = useState(encryptionStatus)

  const [phone, setPhone] = useState('')
  const [digitKey, setDigitKey] = useState('')

  const handleSubmit = async () => {
    const textWithoutSpaces = digitKey.replace(/\s/g, '') //格式化识别结果，去除空格
    if (phone == '') {
      messageInfo(t('Please enter the whatsapp number'))

      return
    }

    if (textWithoutSpaces?.length !== 64) {
      messageInfo(t('Please enter the correct key'))

      return
    }

    let username =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    let result = await androidWaKey({
      googleAccount: username,
      waAccount: phone,
      encryptionKey: textWithoutSpaces
    })
    if (result.data.ec === 0) {
      messageInfo(result.data.em)

      let download = await gcloudDownload({
        mode: 5,
        username: username
      })
      messageInfo(download.data.ed)
      localStorage.setItem('encryption-key', true)
      setIsModalOpen(false)
    }
  }

  const [openBackup, setOpenBackup] = useState(false)

  return (
    <>
      <Modal
        className='equipment'
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        width={700}
        closable={false}
        zIndex={1000}
        footer={[]}
      >
        <div
          style={{
            background: '#E7E7E7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 10px',
            borderTopRightRadius: '8px',
            borderTopLeftRadius: '8px',
            minHeight: '24px'
          }}
        >
          <h2 style={{ color: '#000000', fontSize: '22px' }}></h2>
          <Icon
            icon='ic:round-cancel'
            color='#494949'
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div style={{ padding: '10px' }}>
          <Card style={{ width: '100%', background: '#fff' }}>
            <CardContent>
              <p style={{ textAlign: 'center', fontWeight: '700', color: '#000', fontSize: '16px' }}>
                {t('Enter your 64-digit key')}
              </p>
              <p style={{ color: '#696D6F', marginTop: '10px' }}>
                {t('Enter WhatsApp number') +
                  ' (' +
                  t('include the country code at the start') +
                  ', e.g. ' +
                  t('US is') +
                  '+1, ' +
                  t('UK is') +
                  '+44). ' +
                  t('And paste the 64-digit key') +
                  '.'}
              </p>
              <p
                style={{
                  color: '#3F87A5',
                  textAlign: 'center',
                  marginTop: '10px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 600
                }}
                onClick={() => setOpenBackup(!openBackup)}
              >
                {t('Cant find the 64-digit key')}{' '}
              </p>

              {openBackup ? (
                <div style={{ marginBottom: '10px', marginTop: '20px' }}>
                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step1')}:</span>&ensp;
                    <span>
                      <MoreOutlined className='text-[#000] text-[16px] font-[600]' />
                      {/* <Icon
                        icon='material-symbols:settings-outline'
                        color='#999999'
                        style={{ display: 'inline' }}
                      />{' '}
                      {t('Tap')}  */}
                      &gt; {t('Settings')} &gt; {t('Chats')} &gt; {t('Chat backup')} &gt;{' '}
                      {t('End-to-end encrypted backup')}.
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step2')}:</span>&ensp;
                    <span>
                      {t('Tap')}
                      <span className='font-[600]'> {t('TURN ON')}.</span>
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step3')}:</span>&ensp;
                    <span>
                      {t('Tap')}
                      <span className='font-[600]'> {t('Use a 64-digit encryption key instead')}.</span>
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step4')}:</span>&ensp;
                    <span>
                      {t('Tap')}
                      <span className='font-[600]'> {t('Generate your 64digit key')}.</span>
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step5')}:</span>&ensp;
                    <span>
                      {t('Press and hold 64-digit key click')}
                      <span className='font-[600]'> {t('Copy')}.</span>
                    </span>
                  </p>

                  <p style={{ marginTop: '14px', marginBottom: '10px' }}>
                    {t(
                      'Then you can send the copy to your own phone or just take a picture and upload this one using the button below'
                    )}
                    .
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step6')}:</span>&ensp;
                    <span>
                      {t('Tap')}
                      <span className='font-[600]'> {t('I Saved My 64digit key')}.</span>
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step7')}:</span>&ensp;
                    <span>
                      {t('Tap')}
                      <span className='font-[600]'> {t('Create')} </span>
                      {t('to complete')}.
                    </span>
                  </p>

                  <p style={{ display: 'flex', marginTop: '4px' }}>
                    <span style={{ fontWeight: '500' }}>{t('Step8')}:</span>&ensp;
                    <span>{t('Paste the 64digit key below and click submit')}.</span>
                  </p>
                </div>
              ) : null}

              <input
                placeholder={t('WhatsApp Number')}
                style={{
                  marginTop: '10px',
                  borderRadius: '10px',
                  padding: '0 10px',
                  width: '100%',
                  height: '40px',
                  background: '#F7F8FA',
                  outline: 'none'
                }}
                onChange={e => {
                  setPhone(e.target.value.trim())
                }}
              />

              <TextArea
                className='digit_key'
                rows={4}
                placeholder={t('64-digit key')}
                style={{
                  marginTop: '10px',
                  borderRadius: '10px',
                  padding: '0 10px',
                  width: '100%',
                  background: '#F7F8FA',
                  border: '0',
                  height: '200px'
                }}
                value={digitKey}
                onChange={e => {
                  setDigitKey(e.target.value.trim())
                }}
              />

              <div
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <Button style={{ background: '#3874EA', color: '#fff' }} onClick={() => handleSubmit()}>
                  {t('Continue')}
                </Button>
                <CameraOCR onTextChange={handleTextChange} />
              </div>
            </CardContent>
          </Card>
        </div>
      </Modal>
    </>
  )
}

export default EncryptionKey
